module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-block-view"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "clearfix index-title-block"
  }, [_c('div', {
    staticClass: "pull-left index-title"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.block.name) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right index-title-more"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt10"
  }, _vm._l((_vm.block.items), function(item) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "media hot-block"
    }, [_c('div', {
      staticClass: "pull-right time"
    }), _vm._v(" "), _c('div', {
      staticClass: "media-body title",
      on: {
        "click": function($event) {
          return item.click(_vm.topic)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t")])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-fe77d07a"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/lobby/view/theme/widget/ItemBlock.vue
// module id = 1036
// module chunks = 1